// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Dedicated print fallback for the Advanced Assessment report.
 * Downloads use the deterministic vector renderer in advancedPdfExport.js;
 * these rules keep browser print previews visually aligned with that output.
 */
.advanced-report[data-pdf-export="true"],
.advanced-report[data-pdf-export="true"] *,
.advanced-report[data-pdf-export="true"] *::before,
.advanced-report[data-pdf-export="true"] *::after {
  box-sizing: border-box;
  print-color-adjust: exact !important;
}

.advanced-report[data-pdf-export="true"] {
  isolation: isolate;
  background: #ffffff;
}

.advanced-report[data-pdf-export="true"] .report-status-pill,
.advanced-report[data-pdf-export="true"] .diagnostic-band,
.advanced-report[data-pdf-export="true"] .impact-level,
.advanced-report[data-pdf-export="true"] .transparency-band,
.advanced-report[data-pdf-export="true"] .parameter-donut-status {
  height: 24px;
  min-height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 9px !important;
  line-height: 24px !important;
  text-align: center;
  vertical-align: middle;
}

/* Page 6: fixed gauge, score and mini-stage geometry. */
.advanced-report[data-pdf-export="true"] .parameter-donut-card {
  min-height: 0;
  padding: 9px !important;
  justify-content: flex-start;
}

.advanced-report[data-pdf-export="true"] .parameter-donut-title {
  height: 30px;
  min-height: 30px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  line-height: 1.2 !important;
}

.advanced-report[data-pdf-export="true"] .parameter-donut-gauge {
  width: 112px !important;
  height: 82px !important;
  flex: 0 0 82px;
  overflow: visible;
}

.advanced-report[data-pdf-export="true"] .parameter-donut-score {
  bottom: 5px !important;
  min-height: 43px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  line-height: 1;
}

.advanced-report[data-pdf-export="true"] .parameter-donut-score p {
  margin: 0 !important;
  line-height: 1 !important;
}

.advanced-report[data-pdf-export="true"] .parameter-donut-score p + p {
  margin-top: 3px !important;
}

.advanced-report[data-pdf-export="true"] .parameter-donut-status {
  margin-top: 4px !important;
}

.advanced-report[data-pdf-export="true"] .parameter-mini-chart {
  margin-top: 7px !important;
  padding-top: 7px !important;
}

.advanced-report[data-pdf-export="true"] .parameter-mini-bars {
  height: 48px !important;
  align-items: stretch;
}

.advanced-report[data-pdf-export="true"] .parameter-mini-column {
  height: 48px !important;
  display: grid !important;
  grid-template-rows: 15px 33px;
  align-items: stretch;
}

.advanced-report[data-pdf-export="true"] .parameter-mini-value {
  width: 100%;
  height: 15px !important;
  min-height: 15px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 15px !important;
  text-align: center;
}

.advanced-report[data-pdf-export="true"] .parameter-mini-track {
  width: 100%;
  height: 33px;
  min-height: 33px;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
}

.advanced-report[data-pdf-export="true"] .parameter-mini-fill {
  display: block;
  min-height: 2px;
}

.advanced-report[data-pdf-export="true"] .parameter-mini-labels {
  height: 25px;
  margin-top: 4px !important;
  align-items: flex-start;
}

.advanced-report[data-pdf-export="true"] .parameter-mini-label {
  min-height: 25px !important;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin: 0;
  padding-top: 2px;
  line-height: 1.15 !important;
  white-space: normal !important;
}

/* Page 7: one paint box per heatmap cell, with no separated borders. */
.advanced-report[data-pdf-export="true"] .parameter-matrix {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse !important;
  border-spacing: 0 !important;
  overflow: visible;
  border-radius: 0;
}

.advanced-report[data-pdf-export="true"] .parameter-matrix th,
.advanced-report[data-pdf-export="true"] .parameter-matrix td {
  height: 36px;
  padding: 0 7px !important;
  vertical-align: middle !important;
  line-height: 1.2 !important;
  background-clip: border-box !important;
}

.advanced-report[data-pdf-export="true"] .parameter-matrix th {
  line-height: 36px !important;
}

.advanced-report[data-pdf-export="true"] .parameter-matrix td:not(:first-child) {
  text-align: center;
}

/* Page 8: opaque fills prevent alpha-compositing bands in long captures. */
.advanced-report[data-pdf-export="true"] [data-testid="root-cause-analysis"],
.advanced-report[data-pdf-export="true"] .root-cause-list {
  width: 100%;
  background: #ffffff;
}

.advanced-report[data-pdf-export="true"] .root-cause-card {
  width: 100%;
  overflow: hidden;
  border: 1px solid #efb6b6 !important;
  background: #fff5f5 !important;
  background-image: none !important;
  box-shadow: none !important;
}

.advanced-report[data-pdf-export="true"] .root-cause-driver {
  min-height: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-color: #d8e6e3 !important;
  background: #ffffff !important;
}

/* Page 9: collapsed grid and opaque row paint keep stripes cell-perfect. */
.advanced-report[data-pdf-export="true"] [data-testid="input-audit"] table,
.advanced-report[data-pdf-export="true"] [data-testid="raw-input-table"] {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse !important;
  border-spacing: 0 !important;
  overflow: visible;
  border-radius: 0;
}

.advanced-report[data-pdf-export="true"] [data-testid="input-audit"] th,
.advanced-report[data-pdf-export="true"] [data-testid="input-audit"] td {
  padding: 0 5px !important;
  vertical-align: middle !important;
  line-height: 1.25 !important;
  background-clip: border-box !important;
}

.advanced-report[data-pdf-export="true"] [data-testid="input-audit"] thead th {
  height: 34px;
}

.advanced-report[data-pdf-export="true"] [data-testid="input-audit"] tbody tr {
  background: #ffffff;
}

.advanced-report[data-pdf-export="true"] [data-testid="input-audit"] tbody tr:nth-child(even) {
  background: #f3f8f7;
}

.advanced-report[data-pdf-export="true"] [data-testid="input-audit"] tbody td {
  height: 34px;
  background-color: transparent !important;
}

.advanced-report[data-pdf-export="true"] [data-testid="raw-input-table"] td[data-testid^="agg-"] {
  background: #eaf2ef !important;
}

.advanced-report[data-pdf-export="true"] [data-testid="input-audit"] [data-slot="badge"],
.advanced-report[data-pdf-export="true"] [data-testid="input-audit"] .inline-flex {
  vertical-align: middle;
}

/* Page 10: SVG progress bars preserve exact fill colour and percentage. */
.advanced-report .transparency-bar {
  width: 92px;
  height: 10px;
  display: inline-block;
  overflow: visible;
  vertical-align: middle;
}

.advanced-report .transparency-bar-track {
  fill: #e8eeec;
}

.advanced-report .transparency-bar-inverse .transparency-bar-track {
  fill: rgba(255, 255, 255, .28);
}

.advanced-report[data-pdf-export="true"] .transparency-table {
  width: 100%;
  min-width: 0;
  table-layout: fixed;
  border-collapse: collapse !important;
  border-spacing: 0 !important;
  overflow: visible;
  border-radius: 0;
}

.advanced-report[data-pdf-export="true"] .transparency-table th,
.advanced-report[data-pdf-export="true"] .transparency-table td {
  height: 40px;
  padding: 0 9px !important;
  vertical-align: middle !important;
  line-height: 1.2 !important;
  background-clip: border-box !important;
}

.advanced-report[data-pdf-export="true"] .transparency-table th {
  line-height: 40px !important;
}

.advanced-report[data-pdf-export="true"] .transparency-table tbody tr {
  background: #ffffff;
}

.advanced-report[data-pdf-export="true"] .transparency-table tbody tr:nth-child(even):not(.transparency-total) {
  background: #f3f8f7;
}

.advanced-report[data-pdf-export="true"] .transparency-table tbody tr:not(.transparency-total) td {
  background-color: transparent !important;
}

.advanced-report[data-pdf-export="true"] .transparency-table .transparency-total {
  background: #48665c !important;
}

.advanced-report[data-pdf-export="true"] .transparency-table .transparency-total td {
  background: transparent !important;
}

.advanced-report[data-pdf-export="true"] .transparency-score {
  height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.advanced-report[data-pdf-export="true"] .transparency-bar {
  width: 86px;
  height: 10px;
}

@media print {
  @page {
    size: A4 portrait;
    margin: 12mm;
  }

  html,
  body {
    margin: 0 !important;
    padding: 0 !important;
    background: #ffffff !important;
  }

  .advanced-report,
  .advanced-report *,
  .advanced-report *::before,
  .advanced-report *::after {
    box-sizing: border-box;
    print-color-adjust: exact !important;
    transform: none !important;
  }

  .advanced-report-toolbar {
    display: none !important;
  }

  .advanced-report {
    width: 186mm !important;
    max-width: none !important;
    margin: 0 !important;
    overflow: visible !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
  }

  .advanced-report > section {
    page-break-inside: auto;
    break-inside: auto;
  }

  .advanced-report table,
  .advanced-report tr,
  .advanced-report .appendix-card,
  .advanced-report .root-cause-card {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AdvancedAssessmentReport.print.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;;;;EAIE,sBAAsB;EAEtB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;EAKE,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA,uEAAuE;AACvE;EACE,WAAW;EACX,mBAAmB;EACnB,oCAAoC;EACpC,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2EAA2E;AAC3E;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;EACpC,8BAA8B;EAC9B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA,2EAA2E;AAC3E;;EAEE,WAAW;EACX,mBAAmB;EACnB,oCAAoC;EACpC,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,iCAAiC;EACjC,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA,0EAA0E;AAC1E;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,oCAAoC;EACpC,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;EACjC,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,iBAAiB;IACjB,YAAY;EACd;;EAEA;;IAEE,oBAAoB;IACpB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;;;;IAIE,sBAAsB;IAEtB,oCAAoC;IACpC,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,0BAA0B;IAC1B,oBAAoB;IACpB,4BAA4B;IAC5B,oBAAoB;IACpB,2BAA2B;IAC3B,2BAA2B;EAC7B;;EAEA;IACE,uBAAkB;IAAlB,kBAAkB;EACpB;;EAEA;;;;IAIE,mBAAmB;IACnB,wBAAwB;EAC1B;AACF","sourcesContent":["/*\n * Dedicated print fallback for the Advanced Assessment report.\n * Downloads use the deterministic vector renderer in advancedPdfExport.js;\n * these rules keep browser print previews visually aligned with that output.\n */\n.advanced-report[data-pdf-export=\"true\"],\n.advanced-report[data-pdf-export=\"true\"] *,\n.advanced-report[data-pdf-export=\"true\"] *::before,\n.advanced-report[data-pdf-export=\"true\"] *::after {\n  box-sizing: border-box;\n  -webkit-print-color-adjust: exact !important;\n  print-color-adjust: exact !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] {\n  isolation: isolate;\n  background: #ffffff;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .report-status-pill,\n.advanced-report[data-pdf-export=\"true\"] .diagnostic-band,\n.advanced-report[data-pdf-export=\"true\"] .impact-level,\n.advanced-report[data-pdf-export=\"true\"] .transparency-band,\n.advanced-report[data-pdf-export=\"true\"] .parameter-donut-status {\n  height: 24px;\n  min-height: 24px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 9px !important;\n  line-height: 24px !important;\n  text-align: center;\n  vertical-align: middle;\n}\n\n/* Page 6: fixed gauge, score and mini-stage geometry. */\n.advanced-report[data-pdf-export=\"true\"] .parameter-donut-card {\n  min-height: 0;\n  padding: 9px !important;\n  justify-content: flex-start;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-donut-title {\n  height: 30px;\n  min-height: 30px !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  line-height: 1.2 !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-donut-gauge {\n  width: 112px !important;\n  height: 82px !important;\n  flex: 0 0 82px;\n  overflow: visible;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-donut-score {\n  bottom: 5px !important;\n  min-height: 43px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  line-height: 1;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-donut-score p {\n  margin: 0 !important;\n  line-height: 1 !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-donut-score p + p {\n  margin-top: 3px !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-donut-status {\n  margin-top: 4px !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-mini-chart {\n  margin-top: 7px !important;\n  padding-top: 7px !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-mini-bars {\n  height: 48px !important;\n  align-items: stretch;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-mini-column {\n  height: 48px !important;\n  display: grid !important;\n  grid-template-rows: 15px 33px;\n  align-items: stretch;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-mini-value {\n  width: 100%;\n  height: 15px !important;\n  min-height: 15px;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 15px !important;\n  text-align: center;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-mini-track {\n  width: 100%;\n  height: 33px;\n  min-height: 33px;\n  display: flex;\n  align-items: flex-end;\n  overflow: hidden;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-mini-fill {\n  display: block;\n  min-height: 2px;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-mini-labels {\n  height: 25px;\n  margin-top: 4px !important;\n  align-items: flex-start;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-mini-label {\n  min-height: 25px !important;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  margin: 0;\n  padding-top: 2px;\n  line-height: 1.15 !important;\n  white-space: normal !important;\n}\n\n/* Page 7: one paint box per heatmap cell, with no separated borders. */\n.advanced-report[data-pdf-export=\"true\"] .parameter-matrix {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse !important;\n  border-spacing: 0 !important;\n  overflow: visible;\n  border-radius: 0;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-matrix th,\n.advanced-report[data-pdf-export=\"true\"] .parameter-matrix td {\n  height: 36px;\n  padding: 0 7px !important;\n  vertical-align: middle !important;\n  line-height: 1.2 !important;\n  background-clip: border-box !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-matrix th {\n  line-height: 36px !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .parameter-matrix td:not(:first-child) {\n  text-align: center;\n}\n\n/* Page 8: opaque fills prevent alpha-compositing bands in long captures. */\n.advanced-report[data-pdf-export=\"true\"] [data-testid=\"root-cause-analysis\"],\n.advanced-report[data-pdf-export=\"true\"] .root-cause-list {\n  width: 100%;\n  background: #ffffff;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .root-cause-card {\n  width: 100%;\n  overflow: hidden;\n  border: 1px solid #efb6b6 !important;\n  background: #fff5f5 !important;\n  background-image: none !important;\n  box-shadow: none !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .root-cause-driver {\n  min-height: 50px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  border-color: #d8e6e3 !important;\n  background: #ffffff !important;\n}\n\n/* Page 9: collapsed grid and opaque row paint keep stripes cell-perfect. */\n.advanced-report[data-pdf-export=\"true\"] [data-testid=\"input-audit\"] table,\n.advanced-report[data-pdf-export=\"true\"] [data-testid=\"raw-input-table\"] {\n  width: 100%;\n  table-layout: fixed;\n  border-collapse: collapse !important;\n  border-spacing: 0 !important;\n  overflow: visible;\n  border-radius: 0;\n}\n\n.advanced-report[data-pdf-export=\"true\"] [data-testid=\"input-audit\"] th,\n.advanced-report[data-pdf-export=\"true\"] [data-testid=\"input-audit\"] td {\n  padding: 0 5px !important;\n  vertical-align: middle !important;\n  line-height: 1.25 !important;\n  background-clip: border-box !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] [data-testid=\"input-audit\"] thead th {\n  height: 34px;\n}\n\n.advanced-report[data-pdf-export=\"true\"] [data-testid=\"input-audit\"] tbody tr {\n  background: #ffffff;\n}\n\n.advanced-report[data-pdf-export=\"true\"] [data-testid=\"input-audit\"] tbody tr:nth-child(even) {\n  background: #f3f8f7;\n}\n\n.advanced-report[data-pdf-export=\"true\"] [data-testid=\"input-audit\"] tbody td {\n  height: 34px;\n  background-color: transparent !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] [data-testid=\"raw-input-table\"] td[data-testid^=\"agg-\"] {\n  background: #eaf2ef !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] [data-testid=\"input-audit\"] [data-slot=\"badge\"],\n.advanced-report[data-pdf-export=\"true\"] [data-testid=\"input-audit\"] .inline-flex {\n  vertical-align: middle;\n}\n\n/* Page 10: SVG progress bars preserve exact fill colour and percentage. */\n.advanced-report .transparency-bar {\n  width: 92px;\n  height: 10px;\n  display: inline-block;\n  overflow: visible;\n  vertical-align: middle;\n}\n\n.advanced-report .transparency-bar-track {\n  fill: #e8eeec;\n}\n\n.advanced-report .transparency-bar-inverse .transparency-bar-track {\n  fill: rgba(255, 255, 255, .28);\n}\n\n.advanced-report[data-pdf-export=\"true\"] .transparency-table {\n  width: 100%;\n  min-width: 0;\n  table-layout: fixed;\n  border-collapse: collapse !important;\n  border-spacing: 0 !important;\n  overflow: visible;\n  border-radius: 0;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .transparency-table th,\n.advanced-report[data-pdf-export=\"true\"] .transparency-table td {\n  height: 40px;\n  padding: 0 9px !important;\n  vertical-align: middle !important;\n  line-height: 1.2 !important;\n  background-clip: border-box !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .transparency-table th {\n  line-height: 40px !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .transparency-table tbody tr {\n  background: #ffffff;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .transparency-table tbody tr:nth-child(even):not(.transparency-total) {\n  background: #f3f8f7;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .transparency-table tbody tr:not(.transparency-total) td {\n  background-color: transparent !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .transparency-table .transparency-total {\n  background: #48665c !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .transparency-table .transparency-total td {\n  background: transparent !important;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .transparency-score {\n  height: 40px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1;\n}\n\n.advanced-report[data-pdf-export=\"true\"] .transparency-bar {\n  width: 86px;\n  height: 10px;\n}\n\n@media print {\n  @page {\n    size: A4 portrait;\n    margin: 12mm;\n  }\n\n  html,\n  body {\n    margin: 0 !important;\n    padding: 0 !important;\n    background: #ffffff !important;\n  }\n\n  .advanced-report,\n  .advanced-report *,\n  .advanced-report *::before,\n  .advanced-report *::after {\n    box-sizing: border-box;\n    -webkit-print-color-adjust: exact !important;\n    print-color-adjust: exact !important;\n    transform: none !important;\n  }\n\n  .advanced-report-toolbar {\n    display: none !important;\n  }\n\n  .advanced-report {\n    width: 186mm !important;\n    max-width: none !important;\n    margin: 0 !important;\n    overflow: visible !important;\n    border: 0 !important;\n    border-radius: 0 !important;\n    box-shadow: none !important;\n  }\n\n  .advanced-report > section {\n    break-inside: auto;\n  }\n\n  .advanced-report table,\n  .advanced-report tr,\n  .advanced-report .appendix-card,\n  .advanced-report .root-cause-card {\n    break-inside: avoid;\n    page-break-inside: avoid;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
